const qs = require("qs");

export const baseURL = process.env.REACT_APP_DIRKAMPUS_ENDPOINT_URL;
export const basePSURL = process.env.REACT_APP_PUBLIC_ENDPOINT_URL;
export const socketBaseURL = process.env.REACT_APP_PUBLIC_SOCKET_URL;
export const homeUrl = process.env.REACT_APP_PUBLIC_HOME_URL;
export const managementUrl = process.env.REACT_APP_MANAGEMENT_HOME_URL;

export const ppdbUrl = process.env.REACT_APP_PPDB_HOME_URL;
export const counselingUrl = process.env.REACT_APP_COUNSELING_HOME_URL;
export const mediaURL = process.env.REACT_APP_MEDIA_URL;
export const mediaPreloadURL = process.env.REACT_APP_PRELOAD_MEDIA_URL;

const EPStore = {
	getNewAccessToken: { baseURL: basePSURL, url: "api/v2/auth/refresh/", method: "POST" },
	getUserViaToken: { baseURL: basePSURL, url: "api/auth/loggedinuserDetails/", method: "GET" },
	signUp: { baseURL: basePSURL, url: "api/auth/userRegistration/", method: "POST" },
	logIn: { baseURL: basePSURL, url: "api/auth/login/", method: "POST" },
	logout: { baseURL: basePSURL, url: "api/auth/logout/", method: "POST" },
	sendResetLink: { baseURL: basePSURL, url: "api/auth/send-reset-password-link/", method: "POST" },
	resetPassword: { baseURL: basePSURL, url: "api/auth/reset-password/", method: "POST" },
	editUser: { baseURL: basePSURL, url: "api/auth/profile/", method: "PATCH" },
	changePassword: { baseURL: basePSURL, url: "api/auth/change-password/", method: "POST" },
	dashboard: { url: "api/college/dashboard/", method: "GET" },
	globalSearch: { url: "api/college/global_search", method: "GET" },
	favoriteList: { url: "api/user-tracking/favorite/list/", method: "GET" },
	favoriteCount: { url: "api/user-tracking/totalFavoritesForUser", method: "GET" },
	createFavorite: { url: "api/user-tracking/favorite/create/", method: "POST" },
	removeFavorite: { url: "api/user-tracking/favorite/detail/", method: "DELETE" },
	topCitiesView: { url: "api/college/topCitiesView", method: "GET" },
	locationList: { url: "api/college/collegeLocationNames/", method: "GET" },
	locationListWithCount: { url: "api/college/collegeLocationNamesWithCount/", method: "GET" },
	abroadAccreditationList: { url: "api/college/collegeAbroadAccreditationsList/", method: "GET" },
	majorNameList: { url: "api/major/majorNamesList/", method: "GET" },
	facultiesList: { url: "api/major/facultyList/", method: "GET" },
	sectorList: { url: "api/career/sectorNamesListingWithCount/", method: "GET" },
	collegeList: { url: "api/college/list/", method: "GET" },
	majorList: { url: "api/major/majorlist/", method: "GET" },
	careerList: { url: "api/career/list/", method: "GET" },
	scholarshipList: { url: "api/scholarship/list/", method: "GET" },
	collegeDetail: { url: "api/college/detail/", method: "GET" },
	majorDetail: { url: "api/major/majordetails/", method: "GET" },
	careerDetail: { url: "api/career/detail/", method: "GET" },
	scholarshipDetail: { url: "api/scholarship/detail/", method: "GET" },
};

export const generateRequestOptions = (key, options = {}) => {
	if (!key) {
		return null;
	}

	if (options && options.hasOwnProperty("queryParams")) {
		return {
			...EPStore[key],
			url: EPStore[key].hasOwnProperty("baseURL")
				? `${EPStore[key].baseURL}/${EPStore[key].url}${options.urlParams || ""}?${qs.stringify(
						options.queryParams
				  )}`
				: `${baseURL}/${EPStore[key].url}${options.urlParams || ""}?${qs.stringify(
						options.queryParams,
						options.queryOptions
				  )}`,
		};
	}

	if (options && options.hasOwnProperty("urlParams")) {
		return {
			...EPStore[key],
			url: EPStore[key].hasOwnProperty("baseURL")
				? `${EPStore[key].baseURL}/${EPStore[key].url}${options.urlParams}`
				: `${baseURL}/${EPStore[key].url}${options.urlParams}`,
		};
	}

	if (options && options.hasOwnProperty("innerUrlParams")) {
		let url = Object.keys(options.innerUrlParams).map((k) => {
			return EPStore[key].url.replace(`{${k}}`, options.innerUrlParams[k]);
		})[Object.keys(options.innerUrlParams).length - 1];
		return {
			...EPStore[key],
			url: EPStore[key].hasOwnProperty("baseURL") ? `${EPStore[key].baseURL}/${url}` : `${baseURL}/${url}`,
		};
	}
	return {
		...EPStore[key],
		url: EPStore[key].hasOwnProperty("baseURL")
			? `${EPStore[key].baseURL}/${EPStore[key].url}`
			: `${baseURL}/${EPStore[key].url}`,
	};
};
export const generateURL = (key) => {
	return `${homeUrl}/${EPStore[key].url}`;
};
